import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store';
import fetchAPI from '../../../common/fetchAPI'
import { EmployeeProjectStateClass } from './interfaces/employeeClass';

const initialState: EmployeeProjectStateClass = {
    isLoading: true,
    isCanvasLoading: false,
    isCanvasOpen: false,
    status: 'idle',
    accountEmployeeId: 0,
    isReload: false,
    ////////
    employeeProjectList: [],
    //pagination
    startRec: 0,
    search: '',
    pageNo: 1,
    pageSize: 10,
    totalItems: 0,
    recordsFiltered: 0,
    isSearch: false,
    isShowGrid: false,
    // columnIndex: 0,
    // direction: "asc",
    sortOrder: 'asc',
    sortColumn: '4',
}

interface IThunkApi {
    state: {
        employeeProject: EmployeeProjectStateClass;
    }
}

export const getAssignedEmployeeProject = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/getAssignedEmployeeProject',
        async (arg, thunkApi) => {
            // const { AccountEmployeeId, pageNo, pageSize, startRec, search, columnIndex, direction, IsSelected } = arg;
            const { AccountEmployeeId, pageNo, pageSize, startRec, search, IsSelected } = arg;
            const { sortColumn, sortOrder } = thunkApi.getState().employeeProject;
            // const response = await fetchAPI('api/V2/Employees/AccountEmployeeProjectDatatable?AccountEmployeeId=' + AccountEmployeeId + '&IsSelected=' + IsSelected + '&page=' + pageNo + '&pageSize=' + pageSize + '&start=' + startRec + '&Order=' + columnIndex + '&OrderDir=' + direction + '&search=' + search, 'Get', '', true, '');
            const response = await fetchAPI('api/V2/Employees/AccountEmployeeProjectDatatable?AccountEmployeeId=' + AccountEmployeeId + '&IsSelected=' + IsSelected + '&page=' + pageNo + '&pageSize=' + pageSize + '&start=' + startRec + '&Order=' + sortColumn + '&OrderDir=' + sortOrder + '&search=' + search, 'Get', '', true, '');
            const json = await response.json();
            return json;
        }
    )

export const UpdateSelectedProjects = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Employees/V2/UpdateSelectedProjects',
        async (arg, thunkApi) => {
            const { AccountEmployeeId, List, IsSelected } = arg;
            let filteredList: any = [];
            filteredList = List.filter((item: any) => item.isSelected === 1);
            const response = await fetchAPI('api/v2/Employees/UpdateSelectedProjects/' + AccountEmployeeId + '/' + IsSelected, 'PUT', filteredList, true, 'd8667f9b-57fd-4ca8-9496-59cbebb5f944');
            const json = await response.json();
            return json;
        }
    )

export const employeeProjectSlice = createSlice({
    name: 'employeeProject',
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageNo = action.payload.pageNumber;
            state.startRec = action.payload.start;
            state.search = action.payload.search;
        },
        updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateIsLoading: (state, action: PayloadAction<boolean>) => {
            state.isLoading = action.payload;
        },
        updateIsCanvasLoading: (state, action: PayloadAction<boolean>) => {
            state.isCanvasLoading = action.payload;
        },
        checkedState: (state, action) => {
            const { AccountEmployeeProjectId, AccountProjectId } = action.payload;
            const currentindex = state.employeeProjectList.findIndex((item) => (item.AccountProjectEmployeeId ? item.AccountProjectEmployeeId : item.AccountEmployeeId) == AccountEmployeeProjectId && item.AccountProjectId == AccountProjectId);
            const newArray = [...state.employeeProjectList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.employeeProjectList = newArray;
        },
        unCheckedState: (state, action) => {
            const { AccountEmployeeProjectId, AccountProjectId } = action.payload;
            const currentindex = state.employeeProjectList.findIndex((item) => (item.AccountProjectEmployeeId ? item.AccountProjectEmployeeId : item.AccountEmployeeId) == AccountEmployeeProjectId && item.AccountProjectId == AccountProjectId);
            const newArray = [...state.employeeProjectList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.employeeProjectList = newArray;
        },
        checkedAllState: (state) => {
            const newArray = state.employeeProjectList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.employeeProjectList = newArray;
        },
        unCheckedAllState: (state) => {
            const newArray = state.employeeProjectList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.employeeProjectList = newArray;
        },
        // setSortConfig: (state, action) => {
        //     const { Index, Dir } = action.payload;
        //     state.direction = Dir;
        //     state.columnIndex = Index;
        // },
        setPageSize: (state, action) => {
            state.pageSize = action.payload;
        },
        setSearchValue: (state, action) => {

            state.search = action.payload;
            state.pageNo = 1;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.start;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.currentPage;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAssignedEmployeeProject.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAssignedEmployeeProject.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                if (Object.keys(JSON.parse(payload.data)).length === 0) {
                    state.employeeProjectList = [];
                }
                else {
                    state.employeeProjectList = JSON.parse(payload.data);
                    state.employeeProjectList.map((item: any) => {
                        item.isSelected = 0
                    });
                }
                state.startRec = payload.start
                state.pageNo = payload.currentPage;
                state.totalItems = payload.recordsTotal;
                state.search = payload.search;
                state.recordsFiltered = payload.recordsFiltered;
                state.isLoading = false;
                state.isReload = false;
            })
            .addCase(getAssignedEmployeeProject.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
            .addCase(UpdateSelectedProjects.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(UpdateSelectedProjects.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
                state.isLoading = false;
            })
            .addCase(UpdateSelectedProjects.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
            })
    }
})

export const {
    updatePagination,
    updateSearchPagination,
    updateIsLoading,
    updateIsCanvasLoading,
    checkedAllState,
    unCheckedAllState,
    checkedState,
    unCheckedState,
    setPageSize,
    setSearchValue,
    updateSorting
} = employeeProjectSlice.actions

export const EmployeeProjectState = (state: RootState) => state.employeeProject
export default employeeProjectSlice.reducer